module.exports = __webpack_public_path__ + "img/apache.bda8d861.svg";